import { generateActivityFiltersV3 } from '../utils';
/**
 * This is the query builder for the v3 - activities API
 *
 * @param filters
 */
const generateV3ActivityFilters = (filters = {}) => {
  const {
    // discard as these aren't supported by this query
    limit,
    ...restFilters
  } = filters;
  return generateActivityFiltersV3(restFilters);
};
export default generateV3ActivityFilters;